import React from "react";
import Select2 from "react-select2-wrapper";
import I18 from "../../shared/I18";

export default class Filter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mode: this.props.mode,
            placeholder: this.props.placeholder || 'Airline',
        };
    }

    static get ORDER_ALPHABETICAL_ASC () {
        return 'aza';
    }
    static get ORDER_ALPHABETICAL_DESC () {
        return 'azd';
    }
    static get ORDER_RATING_ASC () {
        return 'ratinga';
    }
    static get ORDER_RATING_DESC () {
        return 'ratingd';
    }

    handleModeSwitch(mode) {
        this.props.onModeChange(mode);
        this.setState({
            mode: mode
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.mode !== this.state.mode) {
            this.setState({ mode: nextProps.mode });
        }
    }

    onSelectBoxOpen() {
        jb.select2.addCustomBoxClass();
    }

    render() {
        const orderOptions = [
            { text: I18.t("airlineListApp.filter.order.alphabetical.asc","A-Z"), id: Filter.ORDER_ALPHABETICAL_ASC },
            { text: I18.t("airlineListApp.filter.order.alphabetical.desc","Z-A"), id: Filter.ORDER_ALPHABETICAL_DESC },
            { text: I18.t("airlineListApp.filter.order.rating.asc","Bewertung aufsteigend"), id: Filter.ORDER_RATING_ASC },
            { text: I18.t("airlineListApp.filter.order.rating.desc","Bewertung absteigend"), id: Filter.ORDER_RATING_DESC }
        ];
        return (
            <div className="jb-airline-filter">

                <div className="row jb-row-align-bottom-sm">
                    <div className="col-xs-12 col-sm-4 clearfix">
						<div className="jb-filter-wrapper">
							<p>{I18.t("airlineListApp.filter.search.airline","Airline suchen")}</p>
							<div className="jb-filter-compact">
								<div className="jb-input-icon">
									<svg className="jb-input-svg">
										<use xlinkHref="#Airplane"></use>
									</svg>
                        <input className="jb-filter-input"
                               id="jb-airline-airlineName"
                               type="search"
                               name="search"
                               value={this.props.filter || ''}
                               onChange={this.props.onFilterChange}
                               placeholder={this.state.placeholder} />
								</div>
							</div>
						</div>
					</div>
                    <div className="col-sm-4 hidden">
                        <div className="jb-filter-block jb-filter-block-right jb-filter-block-xs-center">
							<label className={"jb-airline-view jb-filter-grid-selection jb-js-view-switch" + (this.state.mode == 'grid' ? ' active' : '')}>
								<input type="radio" name="jb-airline-list-mode"
									   checked={this.state.mode == 'grid'}
									   onChange={this.handleModeSwitch.bind(this, 'grid')} />
                                {I18.t("airlineListApp.filter.view.desc.grid","Rasteransicht")}
							</label>
							<label className={"jb-airline-view jb-filter-grid-selection jb-js-view-switch" + (this.state.mode == 'list' ? ' active' : '')}>
								<input type="radio" name="jb-airline-list-mode"
									   checked={this.state.mode == 'list'}
									   onChange={this.handleModeSwitch.bind(this, 'list')} />
                                {I18.t("airlineListApp.filter.view.desc.list","Listenansicht")}
							</label>
                        </div>
                    </div>
					<div className="col-xs-12 col-sm-8 jb-filter-orderby">
						<div className="jb-sorting-compact jb-sorting-area jb-filter-block jb-select-transparent">
							<label className="jb-label">{I18.t("airlineListApp.filter.sort.by", "Sortieren nach:")}</label>

							<Select2
								id="jb-airline-order"
								className="js-select2-box"
								data={orderOptions}
								onChange={this.props.onSortingChange}
								onOpen={this.onSelectBoxOpen}
							/>
						</div>
					</div>
                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./AirlineListApp/components/Filter.jsx